import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const RoleSelector = ({ selectedRole, onRoleChange, onSaveChanges, hasChanges, saving }) => {
  const roleOptions = [
    { value: 'admin', label: 'Admin', description: 'Full system access' },
    { value: 'analyst', label: 'Analyst', description: 'View and export data' },
    { value: 'merchant', label: 'Merchant', description: 'Limited access' }
  ];

  return (
    <div className="bg-white rounded-lg border border-border p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">Configure Role Permissions</h3>
          <p className="text-sm text-muted-foreground">Select a role to view and modify its permissions</p>
        </div>
        <div className="flex items-center gap-4">
          <Select
            options={roleOptions}
            value={selectedRole}
            onChange={onRoleChange}
            placeholder="Select role"
            className="w-48"
          />
          {hasChanges && (
            <Button
              onClick={onSaveChanges}
              loading={saving}
              iconName="Save"
            >
              Save Changes
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RoleSelector;